import { BOOKING_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "../../useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export interface ISendSmartQCDeeplinkWhatsappParams {
  card_id: string;
  mobile: string;
  user_id?: string | null;
}

export interface ISendSmartQCDeeplinkWhatsappResponse {
  status: boolean;
  message: string;
}

export const useSendSmartQCDeeplinkWhatsappAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async ({
      card_id,
      mobile,
      user_id,
    }: ISendSmartQCDeeplinkWhatsappParams): Promise<{ status: boolean; message: string }> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const endpoint = BOOKING_APIS?.SMART_QC_DEEPLINK_SEND?.baseURL ?? "";
        const body: Record<string, string> = { card_id, mobile };
        if (user_id) body.user_id = user_id;

        const response = await axios
          .post(endpoint, body, {
            headers: { Authorization: `${accessToken}` },
          })
          .then((res: AxiosResponse<ISendSmartQCDeeplinkWhatsappResponse>) => {
            if (res.data?.status === true) {
              toast.success(res.data?.message || "Link sent on WhatsApp");
              return { status: true, message: res.data?.message ?? "sent" };
            }
            toast.error(res.data?.message || "Failed to send WhatsApp link");
            return { status: false, message: res.data?.message ?? "failed" };
          })
          .catch((e: AxiosError) => {
            sendCurl(e?.config?.["curlCommand"]);
            captureError(e);
            toast.error("Failed to send WhatsApp link");
            return { status: false, message: "failed" };
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        return { status: false, message: "error" };
      }
    },
    [configuration, dispatch, sendCurl, captureError],
  );

  return { execute };
};
